import { render } from "./SpmMetricDisplay.vue?vue&type=template&id=5b9e42f9&scoped=true"
import script from "./SpmMetricDisplay.vue?vue&type=script&lang=ts"
export * from "./SpmMetricDisplay.vue?vue&type=script&lang=ts"

import "./SpmMetricDisplay.vue?vue&type=style&index=0&id=5b9e42f9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b9e42f9"

export default script